module.exports = __webpack_public_path__ + "img/2022-06-08_21-17-36.d1a874d0.jpg";